import React, {Component} from 'react';

class Dropdown extends Component {
	constructor(props) {
		super(props);

		let vTitle = this.props.options[0].name
		let vValue = this.props.options[0].value
		let activeIdx = 0
		this.props.options.map((v, idx) => {
			if(v.value === this.props.value) {
				activeIdx = idx
				vTitle = v.name
				vValue = v.value
			}
		})

		this.state = {
			activeIdx: activeIdx,
			isActive: false,
			vTitle: vTitle,
			vValue: vValue
		}
	}

	componentDidMount() {
	}

	reload() {
		let vTitle = this.props.options[0].name
		let vValue = this.props.options[0].value
		let activeIdx = 0

		this.props.options.map((v, idx) => {
			if(v.value === this.props.value) {
				activeIdx = idx
				vTitle = v.name
				vValue = v.value
			}
		})

		this.setState({
			activeIdx: activeIdx,
			vTitle: vTitle,
			vValue: vValue
		})
		this.forceUpdate()
	}

	openMenu = () => {
		if (!this.props.isDisable) {
			this.setState({
				isActive: true
			}, () => {
				document.addEventListener('click', this.closeMenu);
			})
		}
	}

	closeMenu = (e) => {
		// if (!this.dropdownMenu.contains(e.target)) {
		this.setState({
			isActive: false
		}, () => {
			document.removeEventListener('click', this.closeMenu);
		});
		// }
	}

	selectMenu = (v, idx) => {
		this.setState({
			activeIdx: idx,
			vTitle: v.name,
			vValue: v.value
		})

		this.props.onChange(this.props.name, v.value);

		this.closeMenu()
	}

	render() {
		let disableStyle = {};
		if(this.props.isDisable) {
			disableStyle={
				backgroundColor:"#e9ecef"
			}
		}
		return (
			<div className="mulity-dropdown-cell" style={disableStyle}>
				<div className="form-dropdown">
					<button
						className="btn-dropdown dropdown-small"
						type="button"
						onClick={this.openMenu}>
						{this.state.vTitle}
					</button>
					{
						this.state.isActive &&
						(
							<div className="dropdown-menu show">
								{
									this.props.options.map((v, idx) => {
										return (
											<button
												key={idx}
												className={idx === this.state.activeIdx ? "dropdown-item active" : "dropdown-item"}
												type="button"
												onClick={() => this.selectMenu(v, idx)}
											>
												{v.name}
											</button>
										)
									})
								}
							</div>
						)
					}
				</div>
			</div>
		)
	}
}

export default Dropdown;
